import React from "react";
import PropTypes from "prop-types";

const HeaderTag = ({
  title,
  className,
  isClassName,
  type: Component,
  ...props
}) => {
  return (
    <Component
      className={isClassName ? className : "mt-2"}
      {...props}
    >
      {title}
    </Component>
  );
};

HeaderTag.propTypes = {
  type: PropTypes.any,
  title: PropTypes.string,
  Component: PropTypes.any,
  isClassName: PropTypes.bool,
  className: PropTypes.string
};

export default HeaderTag;
